import { TruckListFilters, Truck } from "@/models/api/trucks/getTrucks";

export function defaultFilters(): TruckListFilters {
  return { zips: null, deliveryDate: null, facilities: null } as TruckListFilters;
}

export function  getTruckCubeWarningLevel(cubesUsed: number, maxCubes: number): number {
  const cubeWarningLevels: Array<number> = [.8, 1]

  var filledPortion = cubesUsed / maxCubes

  for(let i = cubeWarningLevels.length - 1; i >=0; i--)
  {
    if(filledPortion >= cubeWarningLevels[i])
      return i + 1
  }

  return 0
}
